var map = {
	"./Restaurant-1.jpg": 78377,
	"./Restaurant-2.jpg": 86878,
	"./Restaurant-3.jpg": 7035,
	"./Restaurant-4.jpg": 2152,
	"./category-img-1.png": 51658,
	"./category-img-2.png": 65889,
	"./category-img-3.png": 44760,
	"./category-img-4.png": 93751,
	"./category-img-5.png": 48174,
	"./category-img-6.png": 18533,
	"./latest-01.jpg": 32719,
	"./latest-02.jpg": 19104,
	"./latest-03.jpg": 70237,
	"./latest-04.jpg": 15478,
	"./latest-restaurant-1.jpg": 93029,
	"./latest-restaurant-2.jpg": 70426,
	"./latest-restaurant-3.jpg": 34263,
	"./latest-restaurant-4.jpg": 53068
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90552;